module.exports = __webpack_public_path__ + "static/trig_014-4899ec72abb7a378c583e79e98f9539d.webp";